var KeepaliveConfig = function (IdleProvider, KeepaliveProvider) {
    var keepAliveTimerMinutes = 2 * 60; //2 minutes
    var idleTimerMinutes = 4 * 60; //4 minutes
    var keepaliveEndpoint = __baseApiUrl__ + "/participant-web-services/rest/nonauth/keepAlive";

    IdleProvider.idle(idleTimerMinutes);
    IdleProvider.timeout(idleTimerMinutes);
    IdleProvider.keepalive(false);

    KeepaliveProvider.interval(keepAliveTimerMinutes);
    KeepaliveProvider.http(keepaliveEndpoint);
};

KeepaliveConfig.$inject = ["IdleProvider", "KeepaliveProvider"];
export default KeepaliveConfig;
